/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"

import { Container, Row, Col } from "react-bootstrap"

import Header from "./header"
import Navbar from "./navBar"
import { Helmet } from "react-helmet"

const Layout = ({ children, pageInfo }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}

    
    render={data => (
      <>
        <Container fluid className="px-0 main container-full">
          <Row id="titleBar" noGutters className="justify-content-center">
            <Col>
              <Header siteTitle={data.site.siteMetadata.title}/>
            </Col>
          </Row>
          <Navbar pageInfo={pageInfo} siteTitle={data.site.siteMetadata.title} />
          <Row noGutters>
            <Col>
              <Container fluid className="container-full">
                <main>{children}</main>
                <Helmet>
                  <meta charSet="utf-8" />
                  <title>{pageInfo.pageTitle}</title>
                </Helmet>
              </Container>
            </Col>
          </Row>
        </Container>
        <Container fluid className="px-0">
          <Row noGutters>
            <Col className="footer-col">
              <footer>
                <span>
                  <Link
                    to="/"
                    style={{
                      color: `white`,
                      textDecoration: `none`,
                    }}
                  >
                    {data.site.siteMetadata.title}
                  </Link>
                </span>
              </footer>
            </Col>
          </Row>
        </Container>
      </>
    )}
  />
)

export default Layout
